import Vue from 'vue';
import './placeholder-title.scss';

const titleModeClass = 'title-mode';

Vue.directive('placeholder-title', {

  update: function(el: HTMLInputElement|HTMLSelectElement, binding) {
    const selectMode = el.tagName.toLowerCase() === 'select';
    const placeholderTitle = (<HTMLElement>el.parentNode).getElementsByClassName('placeholder-title')[0];

    (<HTMLElement>placeholderTitle).innerText =  binding.value;

    if (document.activeElement !== el ) {
      if (el.value !== '') {
        placeholderTitle.className = el.dataset.defaultClass + ' '+titleModeClass;
      } else {
        placeholderTitle.className = el.dataset.defaultClass;
      }
    }
  },

  inserted: function (el: HTMLInputElement|HTMLSelectElement, binding) {
    const selectMode = el.tagName.toLowerCase() === 'select';
    const placeholderTitle = document.createElement('div');

    el.dataset.defaultClass = 'placeholder-title' + (selectMode ? ' select-mode' : '');

    if (el.className.indexOf('icon') === -1) {
      el.dataset.defaultClass += ' no-icon';
    }

    setTimeout(() => {
      el.dataset.defaultClass += ' animate';
      placeholderTitle.style.display = 'block';
      //placeholderTitle.style.top = ((<HTMLElement>el).clientHeight/2) - (placeholderTitle.clientHeight/2) + 1 + 'px';
    }, 1);

    placeholderTitle.className = el.dataset.defaultClass;
    placeholderTitle.innerText = el.getAttribute('placeholder') || binding.value;
    el.parentNode.insertBefore(placeholderTitle, el);
    el.setAttribute('placeholder', '');

    placeholderTitle.addEventListener("click", function(){
      el.focus();
    });

    if (!selectMode && !el.getAttribute('placeholder-no-focus')) {
      el.addEventListener("focus", function(){
        placeholderTitle.className = el.dataset.defaultClass +' ' + titleModeClass;
      });

      el.addEventListener("blur", function(){
        if (el.value === '') {
          placeholderTitle.className = el.dataset.defaultClass;
        }
      });
    } else {
      el.addEventListener("change", function(){
        placeholderTitle.className = el.dataset.defaultClass +' ' + titleModeClass;
      });
    }
  }
});



// WEBPACK FOOTER //
// ./src/directives/placeholder-title/placeholder-title.ts